module.exports = __webpack_public_path__ + "img/camera-button-disabled.d8d55bdb.svg";